// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1WQKO","row":"styles_row__1D61e"};